<template>
  <b-card>
    <title-name />
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import TitleName from '@/views/Admin/Defines/Supplier_activities/elements/Title.vue'

export default {
  name: 'ActivityForm',
  components: {
    BCard,
    TitleName,
  },
}
</script>
